<template>
  <v-toolbar color="transparent" height="110" flat>
    <v-flex shrink class="pt-3 logo">
      <v-img
        class="hidden-md-and-down"
        height="110"
        width="110"
        contain
        :src="require('../../../assets/signature/logo.png')"
      />
    </v-flex>
    <v-spacer></v-spacer>

    <v-layout class="hidden-md-and-down" justify-end>
      <v-btn text>
        <div class="toolbar-btn">Privacy</div>
      </v-btn>

      <v-btn text>
        <div class="toolbar-btn">Terms of use</div>
      </v-btn>
    </v-layout>

    <v-layout class="hidden-lg-and-up" justify-end>
      <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="(item, i) in items" :key="i" @click="alert('hi')">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </v-layout>
  </v-toolbar>
</template>

<script>
export default {
  data() {
    return {
      isTablet: false,
      items: [
        { title: "Privacy" },
        { title: "Terms of use" }
      ]
    };
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    onResize() {
      this.isTablet = window.innerWidth < 1100;
    }
  }
};
</script>

<style scoped>
.toolbar-title {
  font-family: "Montserrat";
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #fafafa;
}
.toolbar-btn {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #fafafa;
  text-transform: none;
}
.logo {
  margin-left: -30px
}
</style>